export const NE_WELCOME_CREDIT_PROMOTION = 'br-welcome-credit';
